export default "__VITE_ASSET__CHj9Kg5Q__"